<template>
  <div id="main-box" class="page-content" :class="{bottom:list.length > 0}">
    <div class="table-box layui-body" style="left:0;">

      <div class="StatusNav">
        <ul>
          <li v-for="(item,index) in navlist" v-text="item.name+'('+item.count+')'" :class="{'StatusNavActive':item.active}"
            v-on:click="NavSwitch(item.id)"></li>
        </ul>
      </div>

      <div class="xblock layui-form">
        <button class="layui-btn xblock-row">刷新页面</button>
        <div class="layui-input-inline xblock-row">
          <input type="text" name="username" placeholder="请输入UID查询" v-on:keydown.13="ProductList()" v-model="uid"
            autocomplete="off" class="layui-input" />
        </div>
        <button class="layui-btn xblock-row" lay-filter="sreach" v-on:click="ProductList()"><i
          class="fa fa-search"></i></button>
        <span class="x-right xblock-row" v-text="'　共有数据：'+count+ '条'"></span>
        <div class="clear-both"></div>
      </div>

      <table class="layui-table layui-form">
        <thead>
          <tr>
            <th>图片</th>
            <th>站点</th>
            <th>用户</th>
            <th>店铺</th>
            <th>标题</th>
            <th>状态</th>
            <th v-if="ix == 3">失败原因</th>
            <th>时间</th>
            <th>操作</th>
          </tr>
        </thead>
        <tbody v-viewer>
          <tr v-for="(item,index) in list">
            <td>
              <div class="table_img">
                <img :src="item.image">
              </div>
            </td>
            <td v-text="item.country_zh"></td>
            <td v-text="item.uid"></td>
            <td v-text="item.shop_name"></td>
            <td style="min-width: 150px;max-width:400px;">
              <i v-text="item.name"></i>
            </td>
            <td>
              <div style="width: 80px;">
                <i v-if="item.type == 1" class="status-box status-box-orange">待发布</i>
                <i v-else-if="item.type == 2" class="status-box status-box-blue">发布中</i>
                <i v-else-if="item.type == 3" class="status-box status-box-green">发布成功</i>
                <i v-else-if="item.type == 5" class="status-box status-box-blue">定时发布</i>
                <i v-else class="status-box status-box-red">发布失败</i>
              </div>
            </td>
            <td style="min-width: 150px;max-width:400px;" v-if="ix == 3" v-text="item.error_msg"></td>
            <td v-text="item.created_at"></td>
            <td class="btn-arr">
              <button class="layui-btn" v-on:click="OpenPage('Detail',item.id)">详情</button>
            </td>
          </tr>
        </tbody>
      </table>

      <!-- transition -->
      <K-Transition :isLoding="isLoding" v-if="isLoding || list.length < 1" style="margin-top: 16px;"></K-Transition>

    </div>

    <!-- 分页 -->
    <div class="page-box"><div id="pagebox" class="pagebox"></div></div>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

  </div>
</template>

<script>
  var self, form, layer, laypage, isRefresh, TimerFun;
  import axios from 'axios'
  import Loading from '@/components/common/Loading.vue'
  import Toast from '@/components/common/Toast.vue'
  import Transition from '@/components/common/Transition.vue'
  export default {
    name: 'Product',
    components: {
      'K-Loading': Loading,
      'K-Toast': Toast,
      'K-Transition': Transition,
    },
    data() {
      return {
        isLoding: true,
        ix: 0,
        id: null,
        uid:null,
        itemid: null,
        loading: false,
        Toast: {
          state: false,
          type: 0,
          txt: null
        },
        page: 1,
        count: 0,
        page_num:20,
        isloding: false,
        boxTop: 0,
        list: [],
        navlist: [{
          id: 0,
          count: 0,
          active: false,
          name: "草稿箱",
        }, {
          id: 4,
          count: 0,
          active: false,
          name: "定时发布",
        }, {
          id: 1,
          count: 0,
          active: false,
          name: "发布中",
        }, {
          id: 2,
          count: 0,
          active: false,
          name: "已发布",
        }, {
          id: 3,
          count: 0,
          active: false,
          name: "发布失败",
        }],
        shopid: 0,
        shops: [],
      }
    },
    updated() {
      if (form) {
        form.render();
      }
    },
    watch: {
      $route: {
        handler(nv, ov) {
          if (!nv.query.ix) {
            self.NavSwitch(0);
          }
        }
      },
      deep: true
    },
    beforeDestroy() {
      clearTimeout(TimerFun);
    },
    updated() {
      if (form) {
        form.render();
      }
    },
    mounted() {
      self = this;
      let id = self.$route.query.id; //采集商品ID
      let ix = self.$route.query.ix; //导航ID

      self.boxTop = document.documentElement.clientHeight / 2 - 97;

      layui.use(['form', 'layer', 'laydate', 'laypage'], function() {
        form = layui.form;
        layer = layui.layer;
        laypage = layui.laypage;

        if (ix) {
          self.ix = ix;
          self.NavSwitch(ix);
        } else {
          self.NavSwitch(0);
        }
        if (id) {
          self.ProductList(id);
        }
        self.get_count();

      });

    },
    methods: {
      ToastFun(type, txt) {
        self.Toast.state = true;
        self.Toast.type = type;
        self.Toast.txt = txt;
      },
      ChangeToast() {
        self.Toast.state = false;
      },
      ProductList(id) {
        let param = new URLSearchParams()
        if (id) {
          param.append('id', id)
        }
        if(self.uid){
          param.append('uid', self.uid)
        }
        param.append('shop_id', self.shopid)
        param.append('type', self.ix)
        param.append('num', self.page_num)
        self.isLoding = true;
        axios({
          method: 'post',
          url: self.GetServerUrl() + '/get_admin_production_list/?page='+self.page,
          data: param,
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(json) {
          self.isLoding = false;
          var json = json.data;
          if (json.code == 200) {
            var datas = json.datas;
            var list = datas.list;
            if (datas.page) {
              self.total = datas.total;
              for (let i in list) {
                list[i].active = false;
              }

              self.list = list;
              self.count = datas.page.count;
              self.ShowPage(self, laypage, "ProductList"); //分页
              $('.pagebox').show();
            }
          } else if (json.code == 401) {
            layer.alert('请先前往登录！', {
              title: "ExShopee",
              closeBtn: 0
            }, function() {
              layer.closeAll();
              self.GoToPage("/");
            });
          } else {
            self.list = [];
            $('.pagebox').hide();

            //自动换页
            if (self.page > 1) {
              self.page -= 1;
              self.ProductList();
            }
          }
        }).catch(function(error) {
          self.isLoding = false;
          self.ToastFun(2, error); //弹窗提醒
        })

      },
      get_count() {
        axios({
          method: 'post',
          url: self.GetServerUrl() + "/p_get_admin_status_number/",
          headers: {
            'token': localStorage.getItem("ExShopee_token")
          }
        }).then(function(response) {

          //返回数据处理
          self.ReturnFuntion(self, response, function(datas) {
            for (let i in self.navlist) {
              self.navlist[i].count = datas.count_arr[i]
            }

            if (datas.count_arr[2] > 0) {
              TimerFun = setTimeout(function() {
                isRefresh = true;
                self.get_count();
              }, 2000)
            } else {
              if (isRefresh) {
                self.ProductList();
                isRefresh = false;
              }
            }
          });

        }).catch(function(error) {
          console.log(error);
        })
      },
      NavSwitch(ix, id) {
        let nix;
        $('.cxall').prop('checked', false);
        self.GoToPage('/AdminProduct?ix=' + ix); // 路由跳转
        for (let i in self.navlist) {
          self.navlist[i].active = false;
          if(self.navlist[i].id == ix){
            nix = i;
          }
        }
        self.navlist[nix].active = true;
        self.ix = ix;
        self.list = [];
        if (id) {
          self.ProductList(id);
        } else {
          self.ProductList();
        }
      },
      OpenPage(url, id) {
        self.$router.push({
          path: url + '?id=' + id
        }) // 路由跳转
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  td {
    padding: 18px 15px;
  }

  .country_select {
    width: 150px;
  }

  .promote-url {
    padding-left: 10px;
    line-height: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/admin/product/Product.vue